import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";


const icons:any[]=[
    {name:'github', url:'https://github.com/pbesra'},
    {name:'linkedin', url:'https://www.linkedin.com/in/prakash-besra-8015a384/'},
    {name:'twitter', url:'https://twitter.com/psbesra'},
    {name:'facebook', url:'https://www.facebook.com/prakash.besra.73/'},
    
];
export const iconMap: { [name: string]: any } = {
  github: GitHubIcon,
  twitter: TwitterIcon,
  facebook: FacebookIcon,
  linkedin: LinkedInIcon,
};
export const getIcons=()=>{
    return icons;
}